<template>
    <form @submit.prevent="validar">
        <div class="row p-3">
            <label class="kt-radio kt-radio--tick kt-radio--brand col" v-for="i in lstTipoPersona" :key="i.id">
                <input type="radio" name="tipo de persona" :value="i" v-model="datos.tipo"
                       v-validate="{required:true,obj:true}" :disabled="true"> {{i.dt1}}
                <span></span>
            </label>
            <span class="form-text text-danger col-12">{{errors.first("tipo de persona")}}</span>
        </div>
        <div class="row">
            <div class="form-group col-md-6 col-12">
                <label><i class="fa fa-asterisk text-danger"></i>Tipo de identificación</label>
                <combo-box v-model="datos.tipoDni" :valid="errors.has('tipo de identificación')" :disabled="true"
                           :opciones="lstTipoDni" name="tipo de identificación"
                           v-validate="{required:true,obj:true}"></combo-box>
                <span class="form-text text-danger">{{errors.first("tipo de identificación")}}</span>
            </div>
            <div class="form-group col-md-6 col-12" v-if="tipo.form===1">
                <label>Número</label>
                <input type="text" class="form-control-plaintext" readonly :value="datos.dni">
            </div>
            <div class="form-group col-md-6 col-12" v-else>
                <label><i class="fa fa-asterisk text-danger"></i>Número</label>
                <input type="text" class="form-control" :class="errors.has('número') && 'is-invalid'"
                       v-model="datos.dni" name="número" v-validate="{required:true,ci:true,length:10,numeric:true}">
                <span class="form-text text-danger">{{errors.first("número")}}</span>
            </div>
            <div class="form-group col-md-6 col-12">
                <label><i class="fa fa-asterisk text-danger"></i>Primer apellido</label>
                <input type="text" class="form-control" :class="errors.has('primer apellido') && 'is-invalid'"
                       v-model="datos.apellido1" name="primer apellido" v-validate="{required:true,max:25}">
                <span class="form-text text-danger">{{errors.first("primer apellido")}}</span>
            </div>
            <div class="form-group col-md-6 col-12">
                <label>Segundo apellido</label>
                <input type="text" class="form-control" :class="errors.has('segundo apellido') && 'is-invalid'"
                       v-model="datos.apellido2" name="segundo apellido" v-validate="{alpha_spaces:true,max:25}">
                <span class="form-text text-danger">{{errors.first("segundo apellido")}}</span>
            </div>
            <div class="form-group col-md-6 col-12">
                <label><i class="fa fa-asterisk text-danger"></i>Primer nombre</label>
                <input type="text" class="form-control" :class="errors.has('primer nombre') && 'is-invalid'"
                       v-model="datos.nombre1" name="primer nombre" v-validate="{required:true,alpha_spaces:true,max:25}">
                <span class="form-text text-danger">{{errors.first("primer nombre")}}</span>
            </div>
            <div class="form-group col-md-6 col-12">
                <label>Segundo nombre</label>
                <input type="text" class="form-control" :class="errors.has('segundo nombre') && 'is-invalid'"
                       v-model="datos.nombre2" name="segundo nombre" v-validate="{alpha_spaces:true,max:25}">
                <span class="form-text text-danger">{{errors.first("segundo nombre")}}</span>
            </div>
            <div class="form-group col-md-6 col-12">
                <label><i class="fa fa-asterisk text-danger"></i>Género</label>
                <combo-box v-model="datos.genero" :opciones="lstGenero" :valid="errors.has('género')" name="género"
                           v-validate="{required:true,obj:true}"></combo-box>
                <span class="form-text text-danger">{{errors.first("género")}}</span>
            </div>
            <div class="form-group col-md-6 col-12">
                <label><i class="fa fa-asterisk text-danger"></i>Fecha de nacimiento</label>
                <input type="tel" class="form-control"
                       placeholder="dd/mm/yyyy"
                       v-mask="'##/##/####'"
                       v-model="datos.fecha"
                       name="fecha de nacimiento"
                       :class="errors.has('fecha de nacimiento') && 'is-invalid'"
                       v-validate="{required:true,date_format:'dd/MM/yyyy',date_between:[maximaEdad,minimaEdad,true]}">
                <span class="form-text text-danger">{{errors.first("fecha de nacimiento")}}</span>
            </div>
            <div class="form-group col-md-6 col-12">
                <label><i class="fa fa-asterisk text-danger"></i>Nacionalidad</label>
                <combo-box v-model="datos.nacionalidad" :valid="errors.has('nacionalidad')" :opciones="lstNacionalidad"
                           name="nacionalidad" v-validate="{required:true,obj:true}"></combo-box>
                <span class="form-text text-danger">{{errors.first("nacionalidad")}}</span>
            </div>
            <template v-if="tipo.form===1">
                <div class="form-group col-md-6 col-12">
                    <label><i class="fa fa-asterisk text-danger"></i>Ciudad de nacimiento</label>
                    <input type="text" class="form-control" :class="errors.has('ciudad de nacimiento') && 'is-invalid'"
                           v-model="datos.lugar" name="ciudad de nacimiento"
                           v-validate="{required:true,alpha_spaces:true,max:80}">
                    <span class="form-text text-danger">{{errors.first("ciudad de nacimiento")}}</span>
                </div>

                <div class="form-group col-md-6 col-12">
                    <label><i class="fa fa-asterisk text-danger"></i>Estado civíl</label>
                    <combo-box v-model="datos.estado" :valid="errors.has('estado civíl')" :opciones="lstEstadoCivil"
                               name="estado civíl" v-validate="{required:true,obj:true}"></combo-box>
                    <span class="form-text text-danger">{{errors.first("estado civíl")}}</span>
                </div>
                <div class="form-group col-md-6 col-12">
                    <label><i class="fa fa-asterisk text-danger"></i>Cargas familiares</label>
                    <input type="text" class="form-control" :class="errors.has('cargas familiares') && 'is-invalid'"
                           v-model="datos.cargas" name="cargas familiares"
                           v-validate="{required:true,numeric:true,min_value:1}">
                    <span class="form-text text-danger">{{errors.first("cargas familiares")}}</span>
                </div>
                <div class="form-group col-md-6 col-12">
                    <label><i class="fa fa-asterisk text-danger"></i>Tipo dirección</label>
                    <combo-box v-model="datos.direccion" :valid="errors.has('dirección')" :opciones="lstTipoDireccion"
                               name="dirección" v-validate="{required:true,obj:true}"></combo-box>
                    <span class="form-text text-danger">{{errors.first("dirección")}}</span>
                </div>
                <div class="form-group col-md-6 col-12">
                    <label><i class="fa fa-asterisk text-danger"></i>Provincia</label>
                    <combo-box v-model="datos.provincia" :valid="errors.has('provincia')" :opciones="lstProvincias"
                               name="provincia" v-validate="{required:true,obj:true}"></combo-box>
                    <span class="form-text text-danger">{{errors.first("provincia")}}</span>
                </div>
                <div class="form-group col-md-6 col-12">
                    <label><i class="fa fa-asterisk text-danger"></i>Ciudad</label>
                    <combo-box v-model="datos.ciudad" :valid="errors.has('ciudad')" :opciones="lstCantones"
                               name="ciudad" v-validate="{required:true,obj:true}"></combo-box>
                    <span class="form-text text-danger">{{errors.first("ciudad")}}</span>
                </div>
                <div class="form-group col-md-6 col-12">
                    <label>Parroquia</label>
                    <combo-box v-model="datos.parroquia" :valid="errors.has('parroquia')" :opciones="lstParroquias"
                               name="parroquia"></combo-box>
                    <span class="form-text text-danger">{{errors.first("parroquia")}}</span>
                </div>
                <div class="form-group col-md-6 col-12">
                    <label><i class="fa fa-asterisk text-danger"></i>Calle principal</label>
                    <input type="text" class="form-control" :class="errors.has('calle principal') && 'is-invalid'"
                           v-model="datos.calle1" name="calle principal" v-validate="{required:true,max:50}">
                    <span class="form-text text-danger">{{errors.first("calle principal")}}</span>
                </div>
                <div class="form-group col-md-6 col-12">
                    <label><i class="fa fa-asterisk text-danger"></i>Nro calle</label>
                    <input type="text" class="form-control" :class="errors.has('número calle') && 'is-invalid'"
                           v-model="datos.numeroCalle" name="número calle" v-validate="{required:true}">
                    <span class="form-text text-danger">{{errors.first("número calle")}}</span>
                </div>
                <div class="form-group col-md-6 col-12">
                    <label><i class="fa fa-asterisk text-danger"></i>Calle secundaria</label>
                    <input type="text" class="form-control" :class="errors.has('calle secundaria') && 'is-invalid'"
                           v-model="datos.calle2" name="calle secundaria" v-validate="{required:true,max:20}">
                    <span class="form-text text-danger">{{errors.first("calle secundaria")}}</span>
                </div>
                <div class="form-group col-md-6 col-12">
                    <label>Barrio</label>
                    <input type="text" class="form-control" :class="errors.has('barrio') && 'is-invalid'"
                           v-model="datos.barrio" name="barrio" v-validate="{required:false,max:50}">
                    <span class="form-text text-danger">{{errors.first("barrio")}}</span>
                </div>
                <div class="form-group col-md-6 col-12">
                    <label>Manzana</label>
                    <input type="text" class="form-control" :class="errors.has('manzana') && 'is-invalid'"
                           v-model="datos.manzana" v-validate="{max:50}" name="manzana">
                    <span class="form-text text-danger">{{errors.first("manzana")}}</span>
                </div>
                <div class="form-group col-md-6 col-12">
                    <label>Referencia</label>
                    <input type="text" class="form-control" :class="errors.has('referencia') && 'is-invalid'"
                           v-model="datos.referencia" v-validate="{max:50}" name="referencia">
                    <span class="form-text text-danger">{{errors.first("referencia")}}</span>
                </div>
            </template>
            <div class="form-group col-md-6 col-12">
                <label>Teléfono fijo</label>
                <input type="tel" class="form-control" :class="errors.has('teléfono fijo') && 'is-invalid'"
                       v-model="datos.telefono" name="teléfono fijo" v-validate="{required:false,...valTelf.fijo}">
                <span class="form-text text-danger">{{errors.first("teléfono fijo")}}</span>
            </div>
            <div class="form-group col-md-6 col-12">
                <label><i class="fa fa-asterisk text-danger"></i>Teléfono celular</label>
                <input type="tel" class="form-control" :class="errors.has('teléfono celular') && 'is-invalid'"
                       v-model="datos.celular" name="teléfono celular" v-validate="{required:true,...valTelf.celular}">
                <span class="form-text text-danger">{{errors.first("teléfono celular")}}</span>
            </div>
            <div class="form-group col-md-6 col-12">
                <label><i class="fa fa-asterisk text-danger" v-if="tipo.form===1"></i>Correo electrónico</label>
                <input type="text" class="form-control" :class="errors.has('correo electrónico') && 'is-invalid'"
                       v-model="datos.correo" name="correo electrónico" v-validate="{required:tipo.form===1,max:50}">
                <span class="form-text text-danger">{{errors.first("correo electrónico")}}</span>
            </div>
            <div class="form-group col-md-6 col-12" v-if="tipo.form===1">
                <label><i class="fa fa-asterisk text-danger"></i>Origen de fondos</label>
                <input type="text" class="form-control" :class="errors.has('origen de fondos') && 'is-invalid'"
                       v-model="datos.origenFondo" name="origen de fondos" v-validate="{required:true,max:80}">
                <span class="form-text text-danger">{{errors.first("origen de fondos")}}</span>
            </div>
            <template v-if="peps && tipo.form===1">
                <div class="col-md-12 col-12">
                <span class="kt-switch kt-switch--sm">
                    <label>
                        <input type="checkbox" name="pep" v-model="datos.pep"> ¿Se considera una persona expuesta política o públicamente (PEP)?
                        <span></span>
                    </label>
                </span>
                </div>
                <div class="col-md-12 col-12">
                <span class="kt-switch kt-switch--sm">
                    <label>
                        <input type="checkbox" name="funcionario del gobierno" v-model="datos.funcionarios"> ¿Tiene familiares cercanos o asociados a funcionarios de gobierno?
                        <span></span>
                    </label>
                </span>
                </div>
            </template>
        </div>
        <div class="row pt-4">
            <div class="col-12 col-md-12 p-1">
                <button type="submit" class="btn btn-primary btn-elevate btn-pill btn-block"
                        :class="cargando ? 'kt-spinner kt-spinner--left kt-spinner--sm kt-spinner--light' : ''"
                        :disabled="cargando">Guardar
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    import {persona} from "../../servicios";
    import comboBox from "../comboBox";
    import constantes from "../../constantes";
    import _ from 'lodash';

    const vacio = {id: null, dt1: null};
    export default {
        name: "datosPersonales",
        props: {
            peps: {
                type: Boolean,
                default: true,
            },
            solicitante: {
                type: Object,
                required: false,
            },
            sync: {
                type: Boolean,
                default: false,
            },
            previos: {
                type: Object
            },
            formulario: {
                type: Object,
                required: true
            },
            tipo: {
                type: Object,
                required: true
            },
            lstTipoDni: {
                type: Array,
                required: true
            },
            lstGenero: {
                type: Array,
                required: true
            },
            lstNacionalidad: {
                type: Array,
                required: true
            },
            lstEstadoCivil: {
                type: Array,
                required: true
            },
            lstProvincias: {
                type: Array,
                required: true
            },
            lstTipoDireccion: {
                type: Array,
                required: true
            },
            lstTipoPersona: {
                type: Array,
                required: true
            }
        },
        components: {
            comboBox
        },
        data: () => ({
            datos: {
                id: null,
                complete: false,
                tipo: null,
                tipoDni: vacio,
                dni: null,
                apellido1: null,
                apellido2: "",
                nombre1: null,
                nombre2: "",
                genero: vacio,
                lugar: null,
                fecha: null,
                nacionalidad: vacio,
                estado: vacio,
                cargas: null,
                direccion: vacio,
                provincia: vacio,
                ciudad: vacio,
                parroquia: vacio,
                calle1: null,
                numeroCalle: null,
                calle2: null,
                barrio: null,
                manzana: null,
                referencia: null,
                telefono: null,
                celular: null,
                correo: null,
                pep: true,
                funcionarios: true,
                cargoPublico: true,
                origenFondo: null,
                nombreFuncionario: null,
                nombrePublico: null,
                desde: null,
                hasta: null,
            },
            lstCantones: [],
            lstParroquias: [],
            cargando: false,
            valTelf: constantes.Constantes.validacion,
        }),
        watch: {
            "previos": function (val) {
                const dto = val;
                if (this.tipo.form === 1) {
                    this.datos.tipoDni = constantes.funciones.buscarArrayPorId(this.lstTipoDni, dto.ndt8);
                    this.datos.tipo = constantes.funciones.buscarArrayPorId(this.lstTipoPersona, dto.ndt6);
                    this.datos.estado = constantes.funciones.buscarArrayPorId(this.lstEstadoCivil, dto.ndt1);
                    this.datos.nombre1 = dto.dt1;
                    this.datos.nombre2 = dto.dt2;
                    this.datos.apellido1 = dto.dt3;
                    this.datos.apellido2 = dto.dt4;
                    this.datos.dni = dto.dt9;
                    this.datos.lugar = dto.dt17;
                    this.datos.telefono = dto.dt19;
                    this.datos.celular = dto.dt20;
                    this.datos.correo = dto.dt21;
                    this.datos.genero = constantes.funciones.buscarArrayPorId(this.lstGenero, dto.ndt2);
                    this.datos.nacionalidad = constantes.funciones.buscarArrayPorId(this.lstNacionalidad, dto.ndt7);

                    this.datos.fecha = constantes.funciones.formatoFechaInverso(dto.ddt1);
                    this.datos.pep = dto.bdt3;
                    this.datos.funcionarios = dto.bdt4;
                    this.datos.cargoPublico = dto.bdt5;
                    this.datos.cargas = dto.ndt5;
                    this.datos.origenFondo = dto.dt8;

                    if (dto.elements.length) {
                        this.datos.direccion = constantes.funciones.buscarArrayPorId(this.lstTipoDireccion, dto.elements[0].dt7);
                        this.datos.calle1 = dto.elements[0].dt1;
                        this.datos.calle2 = dto.elements[0].dt2;
                        this.datos.numeroCalle = dto.elements[0].dt3;
                        this.datos.barrio = dto.elements[0].dt5;
                        this.datos.manzana = dto.elements[0].dt6;
                        this.datos.referencia = dto.elements[0].dt4;
                        this.datos.provincia = constantes.funciones.buscarArrayPorId(this.lstProvincias, dto.elements[0].ndt4);
                        setTimeout(() => {
                            this.datos.ciudad = constantes.funciones.buscarArrayPorId(this.datos.provincia.elements, dto.elements[0].ndt2);
                        }, 1000);
                        setTimeout(() => {
                            this.datos.parroquia = constantes.funciones.buscarArrayPorId(this.datos.ciudad.elements, dto.elements[0].ndt3);
                        }, 2000);
                    }
                    this.datos.desde = dto.ndt3;
                    this.datos.hasta = dto.ndt4;
                    this.datos.nombreFuncionario = dto.dt5;
                    this.datos.nombrePublico = dto.dt6;

                }

            },
            // "lstEstadoCivil":function (val) {
            //     constantes.funciones.buscarArrayPorId(this.lstEstadoCivil,val)
            // },
            "datos.estado": function (val) {
                if (val.id && this.tipo.form === 1)
                    this.$emit('cambioEstado', val);
            },
            "datos.provincia.id": function (provincia) {
                this.lstCantones = [];
                this.parroquia = [];
                this.datos.parroquia = vacio;
                this.datos.ciudad = vacio;
                this.lstCantones = this.lstProvincias.find(x => x.id === provincia).elements || [];
            },
            "datos.ciudad.id": function (canton) {
                this.datos.parroquia = vacio;
                if (canton) {
                    this.lstParroquias = [];
                    this.lstParroquias = this.lstCantones.find(x => x.id === canton).elements || [];
                }
            },
          "datos.pep": function (val) {
              this.$emit('cambioPep',val);
          },
            "datos.funcionarios": function (val) {
              this.$emit('cambioFam',val);
                this.datos.nombreFuncionario = null;
            },
            "datos.cargoPublico": function () {
                this.datos.nombrePublico = null;
                this.datos.desde = null;
                this.datos.hasta = null;
            }
        },
        computed: {
            minimaEdad: function () {
                return this.$moment().add(-18, "years").format("DD/MM/YYYY");
            },
            maximaEdad: function () {
                return this.$moment().add(-100, "years").format("DD/MM/YYYY");
            },
            minimaFecha: function () {
                return this.$moment().format("YYYY");
            },
            maximaFecha: function () {
                return this.$moment().add(-100, "year").format("YYYY");
            },
        },
        methods: {
            validar: function () {
                if (this.tipo.form === 2 && this.solicitante.complete === false) {
                    this.$toast.show(`Completa el formulario del Solicitante Datos Personales`);
                    return 0;
                }
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.cargando = true;
                        this.enviarDatos();
                    } else {
                        this.$toast.show(`Completa el formulario ` + this.formulario.id + " " + this.tipo.titulo);
                        setTimeout(() => {
                            let container = this.$el.querySelector('.is-invalid');
                            container.scrollIntoView();
                        }, 100);
                    }
                });
            },
            enviarDatos: _.debounce(function () {
                persona.actualizacionPersonales(this.datos, this.tipo.form, this.previos, this.solicitante).then((response) => {
                    if (this.tipo.form === 2)
                        this.datos.id = response.data.id;
                    this.datos.complete = true;
                    this.cargando = false;
                    this.$emit('input', this.datos);
                }).catch(() => {
                    setTimeout(() => {
                        this.cargando = false;
                    }, 1000);
                });
            }, 2000),
        },
        mounted() {
            const dto = this.previos;
            if (this.tipo.form === 2) {
                this.datos.nombre1 = dto.dt10;
                this.datos.nombre2 = dto.dt11;
                this.datos.apellido1 = dto.dt12;
                this.datos.apellido2 = dto.dt13;
                this.datos.dni = dto.dt18;
                this.datos.telefono = dto.dt22;
                this.datos.celular = dto.dt23;
                this.datos.correo = dto.dt27;
                this.datos.tipoDni = constantes.funciones.buscarArrayPorId(this.lstTipoDni, dto.ndt9);
                this.datos.estado = constantes.funciones.buscarArrayPorId(this.lstEstadoCivil, dto.ndt10);
                this.datos.genero = constantes.funciones.buscarArrayPorId(this.lstGenero, dto.ndt11);
                this.datos.tipo = constantes.funciones.buscarArrayPorId(this.lstTipoPersona, dto.ndt15);
                this.datos.nacionalidad = constantes.funciones.buscarArrayPorId(this.lstNacionalidad, dto.ndt16);
                this.datos.fecha = constantes.funciones.formatoFechaInverso(dto.ddt2);
                this.datos.pep = dto.bdt7;
                this.datos.funcionarios = dto.bdt8;
                this.datos.cargoPublico = dto.bdt9;
                this.datos.tipoDni = constantes.funciones.buscarArrayPorId(this.lstTipoDni, dto.ndt8);
                this.datos.tipo = constantes.funciones.buscarArrayPorId(this.lstTipoPersona, dto.ndt6);
                this.datos.desde = dto.ndt12;
                this.datos.hasta = dto.ndt13;
                this.datos.nombreFuncionario = dto.dt14;
                this.datos.nombrePublico = dto.dt15;
            }
        }
    }
</script>

<style scoped>

</style>
